/**
 * Book/reschedule (web + native) — mark slots whose start time has already passed.
 * `value` is the slot ISO start_time from GET /appointments/slots.
 */
export function isSlotStartInPast(
  startTime: string,
  nowMs: number = Date.now(),
): boolean {
  const startMs = new Date(startTime).getTime();
  if (Number.isNaN(startMs)) {
    return false;
  }
  return startMs <= nowMs;
}

export function withPastSlotsDisabled<
  T extends { value: string; disabled?: boolean },
>(slots: ReadonlyArray<T>, nowMs: number = Date.now()): T[] {
  return slots.map((slot) => {
    if (slot.disabled === true || isSlotStartInPast(slot.value, nowMs)) {
      return { ...slot, disabled: true };
    }
    return slot;
  });
}
